import { useToastStore, type ToastType } from '../store/toastStore';
import { CheckCircle, AlertTriangle, AlertCircle, Info, X } from 'lucide-react';

const iconMap: Record<ToastType, React.ElementType> = {
  success: CheckCircle,
  error: AlertTriangle,
  warning: AlertCircle,
  info: Info,
};

const styleMap: Record<ToastType, string> = {
  success: 'toast-success',
  error: 'toast-error',
  warning: 'toast-warning',
  info: 'toast-info',
};

const iconColorMap: Record<ToastType, string> = {
  success: 'text-success-500',
  error: 'text-danger-600',
  warning: 'text-warning-500',
  info: 'text-primary-400',
};

export default function ToastContainer() {
  const { toasts, removeToast } = useToastStore();

  if (toasts.length === 0) return null;

  return (
    <div className="fixed bottom-6 left-6 z-[100] flex flex-col gap-3 pointer-events-none">
      {toasts.map((t) => {
        const Icon = iconMap[t.type];
        return (
          <div
            key={t.id}
            className={`${styleMap[t.type]} pointer-events-auto`}
            role="alert"
          >
            <Icon className={`w-5 h-5 flex-shrink-0 ${iconColorMap[t.type]}`} />
            <p className="flex-1 text-sm font-medium">{t.message}</p>
            {t.action && (
              <button className="toast-action" onClick={t.action.onClick}>
                {t.action.label}
              </button>
            )}
            <button
              onClick={() => removeToast(t.id)}
              className="p-1 rounded-md hover:bg-white/10 transition-colors flex-shrink-0"
              aria-label="dismiss"
            >
              <X className="w-4 h-4 opacity-60" />
            </button>
          </div>
        );
      })}
    </div>
  );
}
